/* eslint-disable no-else-return */
import {useMemo} from 'react';
// routes
import {paths} from '../routes/paths';
// components
import SvgColor from '../components/svg-color';
import Iconify from "../components/iconify";

// ----------------------------------------------------------------------

const icon = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{width: 1, height: 1}}/>
);

const ICONS = {
    home: <Iconify icon="material-symbols:home-outline-rounded" width={24} />,
    ingresos: <Iconify icon="lucide:arrow-up-down" width={24} />,
    saldo: <Iconify icon="tdesign:undertake-transaction-filled" width={24} />,
    alertas: <Iconify icon="mdi:chart-box-outline" width={24} />,
    // perfil: <Iconify icon="fluent:money-20-regular" width={24} />,
    perfil: <img src="/icons/behaviour-pattern.svg" alt="perfil" width={24} height={24} />,
    detalles: <Iconify icon="icon-park-outline:transaction" width={24} />,
    credit: <Iconify icon="tabler:credit-card" width={24} />,
};

// ----------------------------------------------------------------------

export function useNavData(files, valid) {

    const user_role = JSON.parse(localStorage.getItem("role"));;

    const data = useMemo(
        () => {
            const pathsNav = [{
                subheader: '',
                items: [
                    {title: 'Inicio', path: paths.financial.root, icon: ICONS.home},
                ],
            }]

            if (!files) {
                pathsNav[0].items.push({
                    title: 'Ingresos y gastos',
                    path: paths.financial.flow,
                    icon: ICONS.ingresos,
                    disabled: true,
                    tooltip: "Carga los datos financieros primero"
                });
                pathsNav[0].items.push({
                    title: 'Evolución del saldo',
                    path: paths.financial.balance,
                    icon: ICONS.saldo,
                    disabled: true,
                    tooltip: "Carga los datos financieros primero"
                });
                pathsNav[0].items.push({
                    title: 'Analítica de consumo',
                    path: paths.financial.consuming,
                    icon: ICONS.alertas,
                    disabled: true,
                    tooltip: "Carga los datos financieros primero"
                });
                pathsNav[0].items.push({
                    title: 'Perfil crediticio',
                    path: paths.financial.credit,
                    icon: ICONS.credit,
                    disabled: true,
                    tooltip: "Carga los datos financieros primero"
                });
                pathsNav[0].items.push({
                    title: 'Perfil conductual',
                    path: paths.financial.profile,
                    icon: ICONS.perfil,
                    disabled: true,
                    tooltip: "Carga los datos financieros primero"
                });
                if(user_role === "admin"){
                    pathsNav[0].items.push({
                        title: 'Detalle transaccional',
                        path: paths.financial.details,
                        icon: ICONS.detalles,
                        disabled: true,
                        tooltip: "Carga los datos financieros primero"
                    });
                }
            } else if (!valid) {
                pathsNav[0].items.push({
                    title: 'Ingresos y gastos',
                    path: paths.financial.flow,
                    icon: ICONS.ingresos,
                    disabled: true,
                    tooltip: "La agregación no es válida"
                });
                pathsNav[0].items.push({
                    title: 'Evolución del saldo',
                    path: paths.financial.balance,
                    icon: ICONS.saldo,
                    disabled: true,
                    tooltip: "La agregación no es válida"
                });
                pathsNav[0].items.push({
                    title: 'Analítica de consumo',
                    path: paths.financial.consuming,
                    icon: ICONS.alertas,
                    disabled: true,
                    tooltip: "La agregación no es válida"
                });
                pathsNav[0].items.push({
                    title: 'Perfil crediticio',
                    path: paths.financial.credit,
                    icon: ICONS.credit,
                    disabled: true,
                    tooltip: "La agregación no es válida"
                });
                pathsNav[0].items.push({
                    title: 'Perfil conductual',
                    path: paths.financial.profile,
                    icon: ICONS.perfil,
                    disabled: true,
                    tooltip: "La agregación no es válida"
                });
                if(user_role === "admin"){
                    pathsNav[0].items.push({
                        title: 'Detalle transaccional',
                        path: paths.financial.details,
                        icon: ICONS.detalles,
                        disabled: true,
                        tooltip: "La agregación no es válida"
                    });
                }
            } else {
                pathsNav[0].items.push({
                    title: 'Ingresos y gastos',
                    path: paths.financial.flow,
                    icon: ICONS.ingresos,
                });
                pathsNav[0].items.push({
                    title: 'Evolución del saldo',
                    path: paths.financial.balance,
                    icon: ICONS.saldo,
                });
                pathsNav[0].items.push({
                    title: 'Analítica de consumo',
                    path: paths.financial.consuming,
                    icon: ICONS.alertas,
                });
                pathsNav[0].items.push({
                    title: 'Perfil crediticio',
                    path: paths.financial.credit,
                    icon: ICONS.credit,
                });
                pathsNav[0].items.push({
                    title: 'Perfil conductual',
                    path: paths.financial.profile,
                    icon: ICONS.perfil,
                });
                if(user_role === "admin"){
                    pathsNav[0].items.push({
                        title: 'Detalle transaccional',
                        path: paths.financial.details,
                        icon: ICONS.detalles,
                    });
                }
            }

            return pathsNav
        },

        [files, valid, user_role]
    );

    return data;
}
